import request from "../libs/request";
import { GoodsItemType, RequestGoodsRentalResponse } from "../types/goods";
import { RentStatusValue } from "../types/rentTypes";
import {
  RentalStockGoodsTypeId,
  RentalStockSummary,
} from "./rentalStockServices";
import { SatisfactionInfo } from "./spaceReservationServices";
import { PageableRequest, PageableResponse } from "./talkServices";

const baseUrl = `${process.env.REACT_APP_API_URL}/v2/manager/goods/rental`;

export type ManagerGoodsRentalListRequest = PageableRequest & {
  storeId?: string;
  status?: RentStatusValue;
};

export type ManagerGoodsRentalServiceSummary = {
  doneCount: number;
  overdueCount: number;
  rentedCount: number;
  requestedCount: number;
  totalServiceCount: number;
};

export type ManagerGoodsRentalListResponse = {
  stockSummary: RentalStockSummary;
  serviceSummary: ManagerGoodsRentalServiceSummary;
  goodsRentalServicePageableItems: PageableResponse<RequestGoodsRentalResponse>;
};

export const getMangerGoodsRentalList = async (
  params: ManagerGoodsRentalListRequest
) => request.get<ManagerGoodsRentalListResponse>(`${baseUrl}/list`, { params });

export type ManagerGoodsRentalItem = {
  actualReturnAt: null;
  canceledAt: null;
  createdAt: string;
  createdBy: number;
  createdByCompanyId: string;
  createdByCompanyName: string;
  createdByName: string;
  createdByMobileNumber: string;
  goodsId: string;
  goodsName: string;
  goodsServiceId: string;
  goodsTypeId: RentalStockGoodsTypeId;
  isReturnByAdmin: null;
  lostDamagedAt: null;
  rentalAt: null;
  rentalBuildingFloorId: string;
  rentalBuildingFloorName: string;
  rentalBuildingId: string;
  rentalBuildingName: string;
  rentalServiceStatus: string;
  rentalStoreId: string;
  rentalStoreName: string;
  returnBuildingFloorId: null;
  returnBuildingFloorName: null;
  returnBuildingId: null;
  returnBuildingName: null;
  returnDueAt: null;
  returnStoreId: null;
  returnStoreName: null;

  satisfactionInfo?: SatisfactionInfo;
};

export const getManagerGoodsRentalDetail = async (goodsServiceId: string) =>
  request.get<ManagerGoodsRentalItem>(`${baseUrl}/detail/${goodsServiceId}`);

export const getGoodsRentalDetailHistory = async (goodsServiceId: string) =>
  request.get<GoodsItemType[]>(`${baseUrl}/detail/history/${goodsServiceId}`);

export const requestGoodsRental = async (stockId: string) =>
  request.post<RequestGoodsRentalResponse>(`${baseUrl}/${stockId}`);

export const cancelManagerGoodsRental = async (goodsServiceId: string) =>
  request.patch(`${baseUrl}/${goodsServiceId}/cancel`);

export const rentManagerGoodsRental = async (goodsServiceId: string) =>
  request.put(`${baseUrl}/${goodsServiceId}/rented`);

export const completeManagerGoodsRental = async (goodsServiceId: string) =>
  request.patch(`${baseUrl}/${goodsServiceId}/completed`);

export const lostDamagedManagerGoodsRental = async (goodsServiceId: string) =>
  request.patch(`${baseUrl}/${goodsServiceId}/lost-damaged`);

export const restoreManagerGoodsRental = async (goodsServiceId: string) =>
  request.patch(`${baseUrl}/${goodsServiceId}/restored`);

export const pushManagerGoodsRental = async (
  goodsServiceId: string,
  content: string
) => request.post(`${baseUrl}/${goodsServiceId}/push`, { content });
